import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

export const REP_COLORS = ["#0F382C", "#2563EB", "#D97706", "#0891B2", "#65A30D", "#DB2777", "#475569", "#B45309"];
export const UNOWNED = "#E11D48";

const popup = (a) => `<b>${a.area}</b><br/>${a.leads} leads · ${a.customers} customers<br/>${a.owners.length ? `Owner: ${a.owners.map((o) => o.name).join(", ")}` : "<span style='color:#E11D48;font-weight:600'>No owner yet</span>"}`;

export function CoverageMap({ areas, colorOf, kitchen, onPick, height = 420 }) {
  const el = useRef(null);
  const map = useRef(null);
  useEffect(() => {
    if (!el.current) return;
    if (!map.current) {
      map.current = L.map(el.current, { zoomControl: true });
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 19, attribution: "© OpenStreetMap" }).addTo(map.current);
    }
    const m = map.current;
    const layer = L.layerGroup().addTo(m);
    areas.forEach((a) => {
      const owned = a.owners.length > 0;
      const color = owned ? colorOf(a.owners[0].id) : UNOWNED;
      L.circleMarker([a.lat, a.lng], { radius: 8 + Math.sqrt(a.leads) * 3, color, weight: 2, fillColor: color, fillOpacity: owned ? 0.35 : 0.2, dashArray: owned ? null : "4 4" })
        .bindPopup(popup(a)).bindTooltip(`${a.area} (${a.leads}) · click to set owner`).on("click", () => onPick(a)).addTo(layer);
    });
    const pts = areas.map((a) => [a.lat, a.lng]);
    if (pts.length) m.fitBounds(L.latLngBounds(pts).pad(0.25), { maxZoom: 14 });
    else m.setView([kitchen.lat, kitchen.lng], 12);
    return () => { layer.remove(); };
  }, [areas, colorOf, kitchen, onPick]);
  useEffect(() => () => { map.current?.remove(); map.current = null; }, []);
  return <div ref={el} style={{ height }} className="z-0 w-full overflow-hidden rounded-2xl border border-[#E7E2D6]" data-testid="coverage-map" />;
}
